
const setClienteLogado = (context, cliente) => {
  context.commit('SET_CLIENTE_LOGADO', cliente)
}

export {
  setClienteLogado
}



// WEBPACK FOOTER //
// ./src/store/cliente/actions.js